export const DISABILITY_TYPES = [
  "Leprosy Cured person",
  "Locomotor Disability",
  "Dwarfism",
  "Cerebral palsy",
  "Muscular Dystrophy",
  "Chronic Neurological conditions",
  "Multiple Sclerosis",
  "Parkinson’s disease",
  "Hearing impairment",
  "Mental illness",
  "Intellectual Disability",
  "Blindness",
  "Low-vision",
  "Hemophilia",
  "Thalassemia",
  "Sickle cell disease",
  "Acid Attack Victims",
  "Speech & Language Disability",
  "Specific Learning Disability",
  "Autism spectrum disorder",
  "Multiple disabilities",
];
